import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { AuthService } from '../../../services/auth.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { Roles } from '../../../models/enums';
import { Router } from '@angular/router';
import { TeamSelectionViewModel } from '../../../models/team/team.model';
import { ODPProjectWorkflowViewModel } from '../../../models/odpprojectworkflow/odpProjectWorkflow.model';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-account-recon-sup-active-team',
  templateUrl: './account-recon-sup-active-team.component.html',
  styleUrls: ['./account-recon-sup-active-team.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatRadioModule,
    ReactiveFormsModule
  ]
})
export class AccountReconSupActiveTeamComponent implements OnInit {

  availableTeams: {
    title: string;
    workflowTaskTitle: string;
    value: TeamSelectionViewModel
  }[] = [];

  showTeams: boolean = true;
  showSubmit: boolean = false;

  hasTeams: boolean = true;

  currentRoleID: Roles;
  currentProject: ODPProjectWorkflowViewModel;
  currentTeamSelection: TeamSelectionViewModel | null = null;

  constructor(
    private accountService: AccountService,
    private authService: AuthService,
    private alertService: AlertService,
    private router: Router
  ) { }

  submitReconTeamSelection() {
    if (this.currentTeamSelection) {
      this.accountService.SetActiveTeam(this.currentTeamSelection);
    }
    else {
      this.accountService.SetActiveTeam(null);
    }

    var newTeam = this.accountService.GetActiveTeam();

    if (newTeam)
      this.alertService.showMessage("Active Team", `Switched active team to ${newTeam.teamId}: ${newTeam.teamMembers}`, MessageSeverity.success);

    this.accountService.SetActiveValsSelected(true);
    this.router.navigate(['/abstract/view/'], { queryParams: { reconSupCoding: true } });
  }

  findMatchingTeam(availableTeamsModels: Array<any>, thisTeam: TeamSelectionViewModel) {
    for (var i = 0; i < availableTeamsModels.length; i++)
      if (availableTeamsModels[i].value.teamId == thisTeam.teamId)
        return availableTeamsModels[i].value;

    return null;
  }

  onTeamChange() {
    console.log(`from onTeamChange, currentProjectSelection = ${this.currentProject} and currentTeamSelection = ${this.currentTeamSelection}`);
    setTimeout(() => {
      this.setPageComponentVisibility();
    });
  }

  setPageComponentVisibility() {
    if (this.currentTeamSelection != null) {
      console.log(`currentProjectSelection is ${this.currentTeamSelection}`);
      this.showSubmit = true;
    }
    else {
      this.showSubmit = false;
    }
    console.log(`from end of setPageVisibility(), showSubmit is ${this.showSubmit}`)
  }


  ngOnInit() {
    this.currentRoleID = this.accountService.GetActiveRole();
    this.currentProject = this.accountService.GetActiveProject();

    if (this.currentRoleID != null && this.currentProject != null) {
      this.getTaskTeams();
    }

  }

  getTaskTeams() {
    var currentUserTeams = this.accountService.GetCurrentUserTeams();

    console.log("currentUserTeams");
    console.log(currentUserTeams);

    for (var i = 0; i < currentUserTeams.length; i++)
      this.availableTeams.push({
        title: currentUserTeams[i].teamId.toString() + ": " + currentUserTeams[i].teamMembers,
        workflowTaskTitle: currentUserTeams[i].workflowTaskTitle, value: currentUserTeams[i]
      });

    console.log("Current team selection");
    console.log(this.currentTeamSelection);
    if (this.currentRoleID != null) {
      this.accountService.GetCurrentUserTeamsObservable(this.currentRoleID, this.currentProject).subscribe({
        next: success => {
          currentUserTeams = this.accountService.GetCurrentUserTeams();

          this.availableTeams = [];

          for (var i = 0; i < currentUserTeams.length; i++) {
            var abscount = currentUserTeams[i].abstractCount;
            var abscountstring = (abscount != -1) ? " (" + currentUserTeams[i].abstractCount + " abstracts)" : "";
            this.availableTeams.push({
              title: currentUserTeams[i].teamId.toString() + ": " + currentUserTeams[i].teamMembers + abscountstring,
              workflowTaskTitle: currentUserTeams[i].workflowTaskTitle, value: currentUserTeams[i]
            });
          }

          this.hasTeams = !(this.availableTeams == null || this.availableTeams.length == 0);

          // If we only have 1 team then just set it here
          if (this.hasTeams && this.availableTeams.length === 1) {
            this.currentTeamSelection = this.availableTeams[0].value;
            this.onTeamChange();
          }
          else if (this.hasTeams && this.availableTeams.length > 0 && this.accountService.GetActiveTeam()) {
            this.currentTeamSelection = this.findMatchingTeam(this.availableTeams, this.accountService.GetActiveTeam());
          }
          this.setPageComponentVisibility();
        },
        error: (error) => {
          console.log("Failed to poll current user teams.");
        }
      });
    }
  }

}
